import { render, staticRenderFns } from "./DestinatariosEmailComponent.vue?vue&type=template&id=0f736d8e&scoped=true"
import script from "./DestinatariosEmailComponent.vue?vue&type=script&lang=js"
export * from "./DestinatariosEmailComponent.vue?vue&type=script&lang=js"
import style0 from "./DestinatariosEmailComponent.vue?vue&type=style&index=0&id=0f736d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f736d8e",
  null
  
)

export default component.exports